<template>
  <base-create
    :title="title"
    :fields="isProvider ? providerFields : makerFields"
    :resourceName="resourceName"
    :breadcrumbs="breadcrumbs"
  />
</template>

<script>

export default {
  data() {
    let reviewItemColumns = [];

    for (let i=1; i<=10; i++) {
      let props = {
        label: `質問${i}`,
        name: `review_item_${i}`,
        type: 'select-reviewset',
        optionType: "common/review_items",
        width: "100%",
        rules: "duplicateSelectCheck"
      };
      reviewItemColumns.push(props)
    }

    reviewItemColumns = [
      ...reviewItemColumns,
      {
        label: `必須`,
        name: `review_item_11`,
        type: 'display-fixeditem'
      }
    ];

    const commonColumns = [
      {
        label: "テンプレート名",
        name: "template_name",
        rules: "required|max:255",
        width: "330px"
      },
      ...reviewItemColumns
    ];

    return {
      title: "新規登録",
      resourceName: "templates",
      providerFields: [
        {
          label: "メーカー",
          name: "maker_id",
          type: 'select',
          rules: "required",
          optionType: "common/makers",
          width: "330px"
        },
        ...commonColumns
      ],
      makerFields: commonColumns
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "レビューテンプレート一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "レビューテンプレート登録",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  created() {
    this.$store.dispatch(`templates/entity/updateAnswerItem`);
  }
};
</script>
